module.exports = __webpack_public_path__ + "static/media/36-15.af9b9f87.mp3";